import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { InitOptions } from 'i18next';
import { i18n } from './i18n';
import { getStoredLanguage } from './languageStorage';
import {
  LANGUAGE_ESTONIAN,
  LANGUAGE_LABELS,
  SUPPORTED_LANGUAGES,
} from './types';

const getDefaultOptions = (): InitOptions => {
  const language = getStoredLanguage();
  const isLabels = language === LANGUAGE_LABELS;

  return {
    fallbackLng: [isLabels ? LANGUAGE_LABELS : LANGUAGE_ESTONIAN],
    supportedLngs: [...SUPPORTED_LANGUAGES],
    lng: language,
    appendNamespaceToCIMode: isLabels,
  };
};

export const I18nProvider: FC<PropsWithChildren<InitOptions>> = (props) => {
  const { children, ...customOptions } = props;
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    i18n
      .init({
        ...getDefaultOptions(),
        ...customOptions,
      })
      .then(() => {
        setIsInitialized(true);
      });
  }, [customOptions]);

  return isInitialized ? children : null;
};
